import axios from 'axios';
import qs from 'qs';

export const getDifferenceLessonById = ({
  lessonId,
  locale,
}: {
  lessonId: string;
  locale?: string;
}) =>
  axios.get(
    `/api/v1/difference-lessons/${lessonId}${locale ? `?${qs.stringify({ locale })}` : ''}`,
  );

export const createDifferenceLesson = (data: any) =>
  axios.post('/api/v1/difference-lessons', data);

export const updateDifferenceLessonById = ({
  lessonId,
  data,
}: {
  lessonId: string;
  data: any;
}) => axios.put(`/api/v1/difference-lessons/${lessonId}`, data);

export const removeDifferenceLessonById = (lessonId: string) =>
  axios.delete(`/api/v1/difference-lessons/${lessonId}`);
